import includes from 'lodash/includes'
import { useUserStore } from '@/store/userStore'

export default function ({ store, redirect, route }) {
  const userStore = useUserStore()

  if (
    userStore.loggedIn &&
    store.state.users.user &&
    (includes(['admin', 'operator', 'editor'], store.state.users.user.role) ||
      store.state.users.user.auxRole === 'officer' ||
      store.state.users.user.auxRole === 'institutional') &&
    !route.fullPath.includes('PasswordFuncionarios') &&
    !route.fullPath.includes('PasswordInstitucionales') &&
    !route.fullPath.includes('forbidden') &&
    store.state.users.user.changedPassword === false
  ) {
    return redirect('/forbidden')
  }
}
